/**
 * 分场状态枚举
 */
export enum BreakdownStatus {
  PREPARING = 'PREPARING', // 筹备中
  SHOOTING = 'SHOOTING', // 拍摄中
  COMPLETED = 'COMPLETED', // 已完成
  PAUSED = 'PAUSED', // 暂停
  CANCELLED = 'CANCELLED', // 已取消
}

/**
 * 数据状态枚举
 */
export enum BreakdownDataStatus {
  NORMAL = 'NORMAL', // 正常
  DELETED = 'DELETED', // 删除
  ARCHIVED = 'ARCHIVED', // 归档
}

/**
 * 分场信息类型（与 breakdown API 一致）
 */
export interface BreakdownInfo {
  breakdownID: string;
  breakdownName: string;
  breakdownFilmID?: string;
  breakdownFilmName?: string;
  breakdownStatus: BreakdownStatus;
  breakdownOwnerID?: string;
  breakdownOrgID?: string;
  breakdownAssigneeID?: string;
  breakdownCreatorID?: string;
  breakdownCreateTime?: string;
  breakdownUpdateTime?: string;
  breakdownDataStatus: BreakdownDataStatus;
  breakdownScriptOverview?: string;
  breakdownTotalSceneNumber?: number;
  /** 仅前端统计用，可选 */
  breakdownTotalDays?: number;
  breakdownTotalBudgetAmount?: number;
  breakdownScenesCount?: number;
}

/**
 * 查询分场参数类型
 */
export interface QueryBreakdownParams {
  breakdownID?: string;
  breakdownName?: string;
  breakdownFilmID?: string;
  breakdownFilmName?: string;
  breakdownStatus?: BreakdownStatus;
  breakdownOrgID?: string;
  breakdownOwnerID?: string;
  breakdownAssigneeID?: string;
  breakdownCreatorID?: string;
  breakdownDataStatus?: BreakdownDataStatus;
}

/**
 * 创建分场参数类型
 */
export interface CreateBreakdownParams {
  breakdownName: string;
  breakdownFilmID?: string;
  breakdownFilmName?: string;
  breakdownStatus?: BreakdownStatus;
  breakdownOwnerID?: string;
  breakdownOrgID?: string;
  breakdownAssigneeID?: string;
  breakdownScriptOverview?: string;
}

/**
 * 更新分场参数类型
 */
export interface UpdateBreakdownParams {
  breakdownName?: string;
  breakdownFilmID?: string;
  breakdownFilmName?: string;
  breakdownStatus?: BreakdownStatus;
  breakdownOwnerID?: string;
  breakdownOrgID?: string;
  breakdownAssigneeID?: string;
  breakdownScriptOverview?: string;
  breakdownDataStatus?: BreakdownDataStatus;
}

/**
 * 预算响应类型（包含用户信息）
 */
export interface BudgetResponse {
  budgetID: string;
  budgetName: string;
  budgetParentID: string;
  budgetFilmID: string;
  budgetLevel: string;
  budgetOwnerID: string;
  budgetAssigneeID: string;
  budgetPartnersID: string;
  budgetCreatorID: string;
  budgetCreateTime: Date;
  budgetUpdateTime: Date;
  budgetDataStatus: string;
  budgetStatus: string;
  budgetTotalAmount: number;
  budgetOverview: string;
  budgetStorageMode: string;
  budgetStorageFolderAddress: string;
  budgetUsedAmount: number;
  budgetUnusedAmount: number;
  budgetExceedingAmount: number;
  budgetCurrency?: string; // 预算主货币
  ownerInfo?: {
    userNickname: string;
    userAvatar: string;
  };
  assigneeInfo?: {
    userNickname: string;
    userAvatar: string;
  };
  partnersInfo?: Array<{
    userNickname: string;
    userAvatar: string;
  }>;
  creatorInfo?: {
    userNickname: string;
    userAvatar: string;
  };
  parentBudgetName?: string;
  filmName?: string;
}
